module.exports = __webpack_public_path__ + "img/back lapped zipper length.9a947a83.png";